import React, { useEffect, useState } from "react";
import { useI18n } from "@/lib/i18n";

/** Warms the browser cache for every preview, gating the grid until it is done. */
export const GridPreloader = ({ photos, onReady }) => {
  const { t } = useI18n();
  const [done, setDone] = useState(0);

  const total = photos.length;

  useEffect(() => {
    if (!total) {
      onReady();
      return;
    }
    let cancelled = false;
    let loaded = 0;
    const bump = () => {
      if (cancelled) return;
      loaded += 1;
      setDone(loaded);
      if (loaded >= total) onReady();
    };
    const imgs = photos.map((p) => {
      const img = new Image();
      img.onload = bump;
      img.onerror = () => {
        if (p.fallback && img.src !== p.fallback) {
          img.onerror = bump;
          img.src = p.fallback;
          return;
        }
        bump();
      };
      img.src = p.thumb;
      return img;
    });
    return () => {
      cancelled = true;
      imgs.forEach((i) => { i.onload = null; i.onerror = null; });
    };
  }, [total, photos, onReady]);

  const pct = total ? Math.round((done / total) * 100) : 100;

  return (
    <div className="fixed inset-0 z-50 bg-[#050505] flex items-center justify-center px-6"
      data-testid="grid-preloader">
      <div className="w-full max-w-sm text-center">
        <p className="eyebrow">{t("preparing_gallery")}</p>
        <p className="mt-6 font-mono-accent text-5xl text-[#D4AF37]" data-testid="preloader-percent">{pct}%</p>
        <div className="mt-7 h-[3px] w-full bg-[#1E1E1E]">
          <div className="h-full bg-[#D4AF37] transition-[width] duration-300 ease-out"
            style={{ width: `${pct}%` }} data-testid="preloader-bar" />
        </div>
        <p className="mt-5 text-xs text-[#707070]" data-testid="preloader-count">
          {done}/{total} {t("photos_cached")}
        </p>
        <p className="mt-3 text-[11px] text-[#5A5A5A] leading-relaxed">{t("preloader_hint")}</p>
      </div>
    </div>
  );
};
